import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {TaskDetails} from '../../../classes/models/admin/TaskDetails';
import {PredictionTaskService} from '../../../services/http/admin/prediction-task.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from '../../../shared/standalone-imports';

@Component({
  selector: 'app-admin-prediction-tasks',
  templateUrl: './admin-prediction-tasks.component.html',
  styleUrls: ['./admin-prediction-tasks.component.less'],
  imports: []
})
export class AdminPredictionTasksComponent implements OnInit {
  private predictionTaskService = inject(PredictionTaskService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** A list of details of all tasks. */
  tasksDetails: TaskDetails[];

  ngOnInit(): void {
    this.updateTasksDetails();
  }

  /**
   * Retrieves a list of task details from backend.
   */
  updateTasksDetails() {
    this.predictionTaskService.getTasksDetails()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: res => this.tasksDetails = res
            });
  }

  /**
   * Enables task by the given task type and then retrieves updated task details from backend.
   * @param taskType the type of task to be enabled.
   */
  enableTask(taskType: string) {
    this.predictionTaskService.enableTask(taskType)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => this.updateTasksDetails()
            });
  }

  /**
   * Disables task by the given task type and then retrieves updated task details from backend.
   * @param taskType the type of task to be disabled.
   */
  disableTask(taskType: string) {
    this.predictionTaskService.disableTask(taskType)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => this.updateTasksDetails()
            });
  }

  /**
   * Resets the task by the given type and then retrieves updated task details from backend.
   * @param taskType the type of task to be reset.
   */
  resetTask(taskType: string) {
    this.predictionTaskService.resetTask(taskType)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.updateTasksDetails()
      });
  }
}
